import { t, Trans } from "@lingui/macro";
import { cn } from "@stylingcv/utils";

type Props = {
  className?: string;
};

export const Copyright = ({ className }: Props) => (
  <div
    className={cn(
      "prose prose-sm prose-zinc flex hidden max-w-none flex-col gap-y-1 text-xs opacity-40 dark:prose-invert",
      className,
    )}
  >
    <span>
      <Trans>
        <Trans>Licensed under CV Ai</Trans>
      </Trans>
    </span>
    <span>{t`By the community, for the community.`}</span>
    <span>
      <Trans>
        By{" "}
        <a href="https://Stylion.com/">
          <Trans>
            <Trans>Stylion</Trans>
          </Trans>
        </a>
      </Trans>
    </span>

    <span className="mt-4">
      {t`Stylion`} {"v1" + appVersion}
    </span>
  </div>
);
